"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJSON = isJSON;
exports.parseJSON = parseJSON;
function isJSON(str) {
    try {
        JSON.parse(str);
        return true;
    }
    catch (err) {
        return false;
    }
}
function parseJSON(str) {
    try {
        return JSON.parse(str);
    }
    catch (err) {
        return null;
    }
}
//# sourceMappingURL=json.js.map